import React from 'react';
import { Starfield } from './components/Starfield';
import { Navbar } from './components/Navbar';
import { Hero } from './components/sections/Hero';
import { Pillars } from './components/sections/Pillars';
import { Events } from './components/sections/Events';
import { Records } from './components/sections/Records';
import { About } from './components/sections/About';
import { Stage } from './components/sections/Stage';
import { Instagram } from './components/sections/Instagram';
import { AstroSwag } from './components/sections/AstroSwag';
import { Newsletter } from './components/sections/Newsletter';
import { Footer } from './components/sections/Footer';

// NOTE: the Artists ("Artists in orbit") section is ARCHIVED, not deleted —
// components/sections/Artists.tsx stays in the repo; re-import + mount it here
// (and restore its NAV_LINKS entry in data/site.ts) to bring it back.
// The standalone Social section is MERGED into Instagram (chip bar at its top);
// components/sections/Social.tsx stays in the repo if the tile layout is ever wanted back.
// The Photo Gallery section is ARCHIVED (Ryan, Aug 29 — placeholder images were
// showing); components/sections/Gallery.tsx stays in the repo — re-import + mount
// between Instagram and AstroSwag to bring it back once real photos exist.

export function App() {
  return (
    /* NOTE: no overflow-x-hidden here — it would make this div a scroll container and
       detach the sections from the page's scroll-snap. Horizontal clipping is done with
       overflow-x: clip on html in snap.css, which does NOT create a scroll container. */
    <div className="app-shell relative min-h-screen w-full bg-void" data-id="element-0" data-mp="38li619vzxvky">
      <Starfield data-id="element-1" data-mp="3dkl3o99ncziw" />
      <Navbar data-id="element-2" data-mp="3dl4mrtb19tyi" />
      <main className="relative z-10" data-id="element-3" data-mp="3dlw4c07spr5s">
        {/* Hero + Pillars form one exact-viewport snap unit (see polish.css .home-unit) */}
        <div className="home-unit" data-id="element-4" data-mp="nxn69ujvv7of">
          <Hero data-id="element-5" data-mp="sudoanf90dch" />
          <Pillars data-id="element-6" data-mp="stub1k0jmd4s" />
        </div>
        <Events data-id="element-7" data-mp="sssr0q1jugax" />
        <Stage data-id="element-8" data-mp="swgk5o3310p4" />
        <Records data-id="element-9" data-mp="36859fxwiety" />
        <Instagram data-id="element-10" data-mp="35oymvdpbcv8" />
        <AstroSwag data-id="element-11" data-mp="356sn718lka4" />
        <About data-id="element-12" data-mp="34nbvtnbp1xo" />
        <Newsletter data-id="element-13" data-mp="38b4mqky1kbc" />
      </main>
      <Footer data-id="element-14" data-mp="3udaxmaph6r5r" />
    </div>
  );
}